import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '../../../core/i18n';
import { BadgeModule } from '../badge';
import { TinyMultipleCartBadgeComponent } from './tiny-multiple-cart-badge.component';

@NgModule({
  imports: [CommonModule, I18nModule, BadgeModule],
  declarations: [TinyMultipleCartBadgeComponent],
  exports: [TinyMultipleCartBadgeComponent],
})
export class TinyMultipleCartBadgeModule {}
